import React, { useEffect } from 'react';
import Robot from "../../assets/images/robo.png";
import { getCookie, setCookie, updateCookie } from '../utility/cookies';
import {stopSpeaking} from "../utility/constants";
function Minibot({openBot, prefLang,setOpenBot,setCloseFloat,socket,events ,setStartChat, botInfo,isLang,setLangSwitcher, closeChatHandler}) {
    // console.log("in minibot",events)
    
    useEffect(()=>{
        // setCookie('appState',null,1)
        // setCookie('newChat', true, 1)
        // updateCookie('preLang', prefLang)
        if(openBot === true){
            updateCookie('openChat','false')

        }
        else{
            updateCookie('openChat','true') 
        }
       
    },[openBot])
   
    const openChatHandler = () => {
        setOpenBot(false); 
        stopSpeaking();
        setCloseFloat(true);
        // document.getElementById("webchatbotBg").classList.remove("show")
    }
    return(
        <div className="talkk-chat-wrapper-c">
            {/* {
                openBot === true ?
                <>
                    <div className="bg-overlay"></div>
                    <div className="mini-bot-open" onClick={openChatHandler}>
                        <i className="bot icon-close-2-1"></i>
                    </div>
                </>
                :
                <> */}
                    <div className="mini-bot-close" onClick={!openBot ? closeChatHandler : openChatHandler}>
                        <div className="bot-img-wrapper">
                            <img src={botInfo?.data?.bot?.profileImagePath ? botInfo?.data?.bot?.profileImagePath : Robot} onError={(e) => ((e.target.src = Robot))} alt="bot icon" />
                        </div>
                    </div>
                {/* </>
            } */}
        </div>
    )
}
export default Minibot;
